const joinForm = document.querySelector('.join-form');
const formOverlay = document.querySelector('.home__overlay');
const actorsJoinBtn = document.querySelector('.actors__joinButton');
const contactJoinBtn = document.querySelector('.contact__button');
const waveJoinBtn = document.querySelector('.contact__image');
const closeBtn = document.querySelector('.join-form__close');
const secondCloseBtn = document.querySelector('.join-form__close-second');

const formActive = () => {
	scrollLock.disablePageScroll(joinForm);
	joinForm.classList.add('is-flex');
	formOverlay.classList.add('is-block');

	gsap.delayedCall(0.01, () => {
		joinForm.classList.add('is-active');
		formOverlay.classList.add('is-active');
	});
};

const formDeActive = () => {
	scrollLock.enablePageScroll(joinForm);
	joinForm.classList.remove('is-active');
	formOverlay.classList.remove('is-active');
	formOverlay.classList.remove('is-block');

	setTimeout(() => {
		document.querySelector('.join-form__content').classList.remove('hidden');
		document.querySelector('.join-form__thanks').classList.add('hidden');
	}, 300);

	gsap.delayedCall(0.2, () => {
		joinForm.classList.remove('is-flex');
	});
};

const formFilter = () => {
	if (joinForm.classList.contains('is-active')) {
		formDeActive();
	} else {
		formActive();
	}
};

const joinFormInit = () => {
	const locationHash = window.location.hash;

	if(locationHash === '#apply') {
		formFilter();
	};

	actorsJoinBtn.addEventListener('click', () => {
		formFilter();
	});

	closeBtn.addEventListener('click', () => {
		formFilter();
	});

	secondCloseBtn.addEventListener('click', () => {
		formFilter();
	});

	contactJoinBtn.addEventListener('click', () => {
		formFilter();
	});

	waveJoinBtn.addEventListener('click', () => {
		formFilter();
	});

	formOverlay.addEventListener('click', () => {
		formFilter();
	});
};

export default joinFormInit;
